export enum SignalEventType {
  newLabUpdate = 'newLabUpdate',
  changeNotificationCount = 'changeNotificationCount',
  NewTicket = 'NewTicket'
}

export interface SignalEvent<TDataShape> {
  type: SignalEventType,
  data: TDataShape
}
